'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createMatchMediaConnect;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _shallowequal = require('shallowequal');

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _throttle = require('./utils/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

var _pick = require('./utils/pick');

var _pick2 = _interopRequireDefault(_pick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function pickState(pickProperties, stateToPickFrom) {
    if (!pickProperties.length) return stateToPickFrom;
    return _pick2.default.apply(undefined, [stateToPickFrom].concat(_toConsumableArray(pickProperties)));
}

function createMatchMediaConnect() {
    var queryMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$matchMediaFn = options.matchMediaFn,
        matchMediaFn = _options$matchMediaFn === undefined ? window.matchMedia : _options$matchMediaFn;

    var mqls = {};
    var listeners = [];
    var state = {};

    function subscribe(listener) {
        listeners.push(listener);
        return function unsubscribe() {
            var index = listeners.indexOf(listener);
            listeners.splice(index, 1);
        };
    }

    function createState() {
        var nextState = {};
        for (var key in mqls) {
            if (!mqls.hasOwnProperty(key)) continue;
            var mql = mqls[key];
            var matches = mql.matches;

            nextState[key] = matches;
        }
        return nextState;
    }

    var handleChange = (0, _throttle2.default)(function () {
        var nextState = createState();
        if ((0, _shallowequal2.default)(state, nextState)) return;
        state = nextState;
        for (var i = 0, l = listeners.length; i < l; i++) {
            var listener = listeners[i];
            if (!listener) continue;
            listener(nextState);
        }
    });

    if (matchMediaFn) {
        for (var key in queryMap) {
            if (!queryMap.hasOwnProperty(key)) continue;
            var query = queryMap[key];
            var mql = matchMediaFn(query);
            mql.addListener(handleChange);
            mqls[key] = mql;
        }
    }

    function destroy() {
        listeners.length = 0;
        for (var _key in mqls) {
            if (!mqls.hasOwnProperty(_key)) continue;
            var _mql = mqls[_key];
            _mql.removeListener(handleChange);
            mqls[_key] = undefined;
        }
    }

    state = createState();

    function connect() {
        var pickProperties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        return function wrapWithConnect(WrappedComponent) {
            return function (_Component) {
                _inherits(WrapWithConnect, _Component);

                function WrapWithConnect(props) {
                    _classCallCheck(this, WrapWithConnect);

                    var _this = _possibleConstructorReturn(this, (WrapWithConnect.__proto__ || Object.getPrototypeOf(WrapWithConnect)).call(this, props));

                    _this.handleChange = _this.handleChange.bind(_this);
                    _this.state = pickState(pickProperties, state);
                    return _this;
                }

                _createClass(WrapWithConnect, [{
                    key: 'componentDidMount',
                    value: function componentDidMount() {
                        this.unsubscribe = subscribe(this.handleChange);
                    }
                }, {
                    key: 'componentWillUnmount',
                    value: function componentWillUnmount() {
                        this.unsubscribe();
                    }
                }, {
                    key: 'handleChange',
                    value: function handleChange(nextState) {
                        var nextPickedState = pickState(pickProperties, nextState);

                        if ((0, _shallowequal2.default)(this.state, nextPickedState)) {
                            return;
                        }
                        this.setState(nextPickedState);
                    }
                }, {
                    key: 'render',
                    value: function render() {
                        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.state));
                    }
                }]);

                return WrapWithConnect;
            }(_react.Component);
        };
    }

    // For testing
    connect.destroy = destroy;
    connect.listeners = listeners;
    return connect;
}